import { render, staticRenderFns } from "./AreaTable.vue?vue&type=template&id=0672db5f&scoped=true"
import script from "./AreaTable.vue?vue&type=script&lang=js"
export * from "./AreaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0672db5f",
  null
  
)

export default component.exports